import { computeOpenStatus, type HoursSource } from "@/lib/opening-hours";

export function HoursStatus({
  source,
  compact = false,
}: {
  source: HoursSource | null | undefined;
  compact?: boolean;
}) {
  if (!source) return null;
  const s = computeOpenStatus(source);
  if (s.state === "unknown" && s.todayLabel === "—") return null;
  const open = s.state === "open" || s.state === "closing_soon";
  return (
    <div className={compact ? "flex flex-wrap items-center gap-1.5" : "flex flex-col gap-0.5"}>
      <span
        className={`inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-widest ${
          open ? "bg-emerald-50 text-emerald-800" : s.state === "unknown" ? "bg-navy/5 text-navy/50" : "bg-navy/8 text-navy/65"
        }`}
      >
        <span className={`size-1.5 rounded-full ${open ? "bg-emerald-500" : "bg-navy/35"}`} />
        {open ? (s.state === "closing_soon" ? "Closing soon" : "Open now") : s.state === "unknown" ? "Hours" : "Closed"}
      </span>
      {s.todayLabel && s.todayLabel !== "—" ? (
        <span style={{ textTransform: "none" }} className={`text-[11px] text-navy/60 ${compact ? "" : "pl-0.5"}`}>
          Today: {s.todayLabel}
        </span>
      ) : null}
    </div>
  );
}
